import type { GlobalAppSettings } from './globalAppSettings.types';

export const getAppSettings = (): GlobalAppSettings => window['appSettings'];
